import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import PageHeader from '../../components/PageHeader';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import * as quizApi from '../../api/quiz.api';
import { errorMessage } from '../../api/client';

// Admin/staff view of every quiz submission. Helps ops spot bottlenecks
// (high NOT_ELIGIBLE rate ⇒ marketing is mistargeting).

function QuizList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setLoading(true);
      try {
        const params = filter ? { eligibilityStatus: filter } : {};
        const list = await quizApi.listAllQuizzes(params);
        if (!cancelled) setItems(list || []);
      } catch (e) {
        if (!cancelled) toast.error(errorMessage(e));
      } finally {
        if (!cancelled) setLoading(false);
      }
    }
    load();
    return () => { cancelled = true; };
  }, [filter]);

  return (
    <>
      <PageHeader
        title="Quiz submissions"
        subtitle="Eligibility quiz history across all customers."
      />

      <div className="card" style={{ marginBottom: 'var(--s-3)' }}>
        <div className="row" style={{ gap: 8, flexWrap: 'wrap' }}>
          {['', 'ELIGIBLE', 'CONDITIONAL', 'NOT_ELIGIBLE'].map((v) => (
            <button
              key={v}
              className={`btn ${filter === v ? 'btn-primary' : 'btn-outline'}`}
              onClick={() => setFilter(v)}
            >
              {v || 'All'}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : items.length === 0 ? (
        <EmptyState title="No submissions" description="Customers haven't taken the quiz yet." />
      ) : (
        <div className="card" style={{ overflowX: 'auto' }}>
          <table className="table">
            <thead>
              <tr>
                <th>When</th>
                <th>Customer</th>
                <th>BMI</th>
                <th>Status</th>
                <th>Reason</th>
                <th>Recommended</th>
              </tr>
            </thead>
            <tbody>
              {items.map((q) => (
                <tr key={q._id}>
                  <td>{new Date(q.createdAt).toLocaleString()}</td>
                  <td>
                    <div className="bold">{q.user?.name || '—'}</div>
                    <div className="muted text-xs">{q.user?.email}</div>
                  </td>
                  <td>{q.basicInfo?.bmi || '—'}</td>
                  <td>
                    <span className={
                      q.eligibilityStatus === 'ELIGIBLE' ? 'badge success' :
                      q.eligibilityStatus === 'CONDITIONAL' ? 'badge warning' :
                      'badge danger'
                    }>
                      {q.eligibilityStatus}
                    </span>
                  </td>
                  <td className="muted text-sm">{q.eligibilityReason || '—'}</td>
                  <td>
                    {q.recommendedBottles
                      ? `${q.recommendedBottles} bottle${q.recommendedBottles > 1 ? 's' : ''} · ${q.recommendedWeeks}w`
                      : '—'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}

export default QuizList;
